import { IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from '../authConfig';

let msalInstance: IPublicClientApplication | null = null;

export const setMsalInstance = (instance: IPublicClientApplication) => {
  msalInstance = instance;
};

const MAGIC_LINK_STORAGE_KEY = 'magicLinkAccessToken';

function decodeJwtExpiryMs(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export const setMagicLinkSession = (accessToken: string) => {
  localStorage.setItem(MAGIC_LINK_STORAGE_KEY, accessToken);
};

export const clearMagicLinkSession = () => {
  localStorage.removeItem(MAGIC_LINK_STORAGE_KEY);
};

/** Returns the stored magic-link token if present and not (client-side, approximately) expired. */
export const getMagicLinkSession = (): string | null => {
  const token = localStorage.getItem(MAGIC_LINK_STORAGE_KEY);
  if (!token) return null;

  const expiresAt = decodeJwtExpiryMs(token);
  if (expiresAt !== null && expiresAt < Date.now()) {
    clearMagicLinkSession();
    return null;
  }

  return token;
};

export const hasMagicLinkSession = (): boolean => getMagicLinkSession() !== null;

export const getAccessToken = async (forceRefresh = false): Promise<string | null> => {
  const magicLinkToken = getMagicLinkSession();
  if (magicLinkToken) return magicLinkToken;

  if (!msalInstance) return null;
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;
  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
      forceRefresh,
    });
    return response.accessToken;
  } catch {
    return null;
  }
};
